const CONTENT_METHODS = {
    ONE_BY_ONE: 'ONE_BY_ONE',
    RSS: 'RSS',
    AI_VARIATIONS: 'AI_VARIATIONS',
};
const CONTENT_METHODS_KEYS_ARRAY = Object.values(CONTENT_METHODS);

export { CONTENT_METHODS, CONTENT_METHODS_KEYS_ARRAY };
